export default "__VITE_ASSET__C7Ykynq7__"